import { render, staticRenderFns } from "./WorkflowInbox.vue?vue&type=template&id=19073d42&scoped=true&"
import script from "./WorkflowInbox.vue?vue&type=script&lang=js&"
export * from "./WorkflowInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19073d42",
  null
  
)

export default component.exports